import React from 'react';
import { useTranslation } from 'react-i18next';
import { RotatingReviews } from './RotatingReviews';
import { AnimatedCounter } from '../ui/AnimatedCounter';

export function Proof() {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-white border-y border-ground-deep">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <h2 className="text-4xl font-serif leading-tight mb-6 text-ink font-normal">
              {t('proof.title', 'A Catalyst for Deep, Enduring Change.')}
            </h2>
            <p className="text-lg text-ink/70 leading-relaxed mb-8">
              {t('proof.desc', 'Organizations and independent coaches worldwide rely on the FIVE LENS framework to move past superficial assessments and uncover the true drivers of human behavior and team dynamics.')}
            </p>
            <div className="flex items-center gap-6 border-t border-ground-deep pt-8 flex-wrap">
              <div>
                <div className="text-4xl font-serif text-rule-3 mb-1 font-normal"><AnimatedCounter end={700} suffix="+" /></div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-ink/70 font-bold">{t('proof.stat1', 'Certified Coaches')}</div>
              </div>
              <div className="w-px h-12 bg-ground-deep hidden sm:block"></div>
              <div>
                <div className="text-4xl font-serif text-rule-3 mb-1 font-normal"><AnimatedCounter end={50} suffix="+" /></div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-ink/70 font-bold">{t('proof.stat2', 'Global Enterprises')}</div>
              </div>
              <div className="w-px h-12 bg-ground-deep hidden sm:block"></div>
              <div>
                <div className="text-4xl font-serif text-rule-3 mb-1 font-normal"><AnimatedCounter end={100} suffix="%" /></div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-ink/70 font-bold">{t('proof.stat3', 'Scientifically Based')}</div>
              </div>
            </div>
          </div>
          
          <div className="lg:col-span-6 lg:col-start-7">
            <RotatingReviews />
          </div>
        </div>
      </div>
    </section>
  );
}
